import Blue from '~/core'
import MenubarNavigation from './_header-menubar'
import DisclosureNav from './_header-disclosure'

new Blue({
  name: 'Header Drawer',
  selector: '.header-drawer',
  setup(drawer) {
    const overlay = document.querySelector('.overlay')
    const body = document.querySelector('body')
    const menuBtn = document.querySelectorAll('.header-drawer-btn')
    document.body.setAttribute('data-drawer', 'false')

    function toggle() {
      const active = document.body.getAttribute('data-drawer') === 'true'
      const page = document.querySelector('.page')
      if (active) {
        document.body.setAttribute('data-drawer', 'false')
        page.inert = false
        body.classList.remove('overflow')
        overlay.classList.remove('overlay--active')
        drawer.classList.remove('open')
      } else {
        document.body.setAttribute('data-drawer', 'true')
        page.inert = true
        body.classList.add('overflow')
        overlay.classList.add('overlay--active')
        drawer.classList.add('open')
      }
    }

    menuBtn.forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.stopPropagation()
        toggle()
      })
    })

    window.onkeydown = function (event) {
      const key = event.key
      const active = document.body.getAttribute('data-drawer') === 'true'
      if (key === 'Escape' && active) {
        toggle()
      }
    }

    document.addEventListener('click', (event) => {
      let target = event.target,
        is_menu = target === drawer || drawer.contains(target),
        is_button = target.classList.contains('header-drawer-btn'),
        active = document.body.getAttribute('data-drawer') === 'true'
      if (!is_menu && !is_button && active) {
        toggle()
      }
    })
  },
})

new Blue({
  name: 'Expand Menu',
  selector: 'ul.menu',
  setup(menu) {
    new DisclosureNav(menu)
  },
})


new Blue({
  name: 'Header Main',
  selector: '.header',
  setup(container) {
    const headerMain = container.querySelector('.header-main')

    const toggleCustomClass = () => {
      container.classList.toggle('stuck', headerMain.getBoundingClientRect().top <= 0)
    }

    window.addEventListener('scroll', toggleCustomClass, { passive: true })
    toggleCustomClass();
  },
})